import { TableCell } from '@material-ui/core';
import React, { FC, memo } from 'react';

interface Props {
  children: React.ReactNode;
  justify?: 'flex-start' | 'center' | 'flex-end' | 'start' | 'end';
}

const AlignedTableCell: FC<Props> = ({ children, justify = 'center' }) => (
  <TableCell>
    <div style={{ display: 'flex', justifyContent: justify }}>{children}</div>
  </TableCell>
);

export default memo(AlignedTableCell);
